import { render, staticRenderFns } from "./ArtigosPublishDialog.vue?vue&type=template&id=24045ab4&scoped=true&"
import script from "./ArtigosPublishDialog.vue?vue&type=script&lang=js&"
export * from "./ArtigosPublishDialog.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosPublishDialog.vue?vue&type=style&index=0&id=24045ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24045ab4",
  null
  
)

export default component.exports